import PostsList from './PostsList';

export type { PostsListProps } from './PostsList';

export default PostsList;
